var $ = global.jQuery = global.$;
require('jquery-ui/datepicker');
require('jquery-ui/themes/base/jquery.ui.datepicker.css');
require('jquery-ui/themes/base/jquery-ui.css');
require('jquery-ui/themes/flick/jquery.ui.theme.css');
var widgets = require('../lib/widgets');

var Field = require('./Field');

var DateField = Field.extend({
  init: function() {
    var self = this;
    this._super();
    this.$input.datepicker({
      dateFormat: self.$input.data('dateFormat'),
      maxDate: "-16y",
      defaultDate: "-18y",
      yearRange: "-100:+0",
      changeMonth: true,
      changeYear: true,
      hideIfNoPrevNext: true,
      onClose: function(dateText, inst) {
      },
      beforeShow: function(input, inst) {

        inst.dpDiv.addClass('month-year-datepicker');
      }
    });
  },
});

module.exports = DateField;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/DateField.js
 ** module id = 288
 ** module chunks = 1
 **/